// extracted by mini-css-extract-plugin
export default {"table-container":"myTable_table-container__Fi1Lg","table-header":"myTable_table-header__dSOq9","table":"myTable_table__H3Yht"};